import { GraduationCap, Award } from "lucide-react";
import { PROFILE, EDUCATION, CERTIFICATIONS } from "../data/portfolio";
import { Reveal } from "./Reveal";
import { CountUp } from "./CountUp";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative border-t border-white/10 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-10 gap-x-0 lg:gap-14 items-start">
          {/* Copy */}
          <div className="col-span-12">
            <Reveal>
              <p className="label-eyebrow">01 / About</p>
              <h2 className="mt-4 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-tight">
                Engineer first.
                <br />
                <span className="text-white/40">AI native.</span>
              </h2>
            </Reveal>

            <div className="mt-8">
              {PROFILE.bio.map((para, i) => (
                <Reveal key={i} delay={i * 120}>
                  <p className="text-base sm:text-lg text-white/75 leading-relaxed mb-6">
                    {para}
                  </p>
                </Reveal>
              ))}

              <Reveal delay={300}>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-12 pt-10 border-t border-white/10">
                  {[
                    { k: "Years", n: 7, suffix: "+" },
                    { k: "Companies", n: 4 },
                    { k: "Projects", n: 6, suffix: "+" },
                    { k: "Domain", v: "Gen AI" },
                  ].map((s, i) => (
                    <div
                      key={s.k}
                      data-testid={`about-stat-${s.k.toLowerCase()}`}
                    >
                      <p className="label-eyebrow">{s.k}</p>
                      <p className="font-display font-bold text-2xl tracking-tighter mt-2">
                        {s.v ? (
                          s.v
                        ) : (
                          <CountUp to={s.n} suffix={s.suffix || ""} duration={1.4 + i * 0.1} />
                        )}
                      </p>
                    </div>
                  ))}
                </div>
              </Reveal>
            </div>
          </div>
        </div>

        {/* Education + Certifications */}
        <div className="grid grid-cols-12 gap-y-10 gap-x-0 lg:gap-14 mt-12 pt-10 border-t border-white/10">
          {/* Education */}
          <div className="col-span-12 lg:col-span-5">
            <Reveal>
              <p className="label-eyebrow">01.a / Education</p>
              <h3 className="mt-4 font-display font-black text-2xl sm:text-3xl tracking-tighter leading-tight">
                Foundations.
              </h3>
            </Reveal>
            <div className="mt-8 space-y-6">
              {EDUCATION.map((e, i) => (
                <Reveal
                  key={e.degree}
                  delay={i * 100}
                  data-testid={`about-education-${i}`}
                  className="border border-white/10 p-6 hover:border-white/30 transition-colors"
                >
                  <div className="flex items-start gap-4">
                    <GraduationCap
                      size={20}
                      className="text-white/60 mt-1 flex-shrink-0"
                    />
                    <div>
                      <h4 className="font-display font-bold text-lg tracking-tight leading-tight">
                        {e.degree}
                      </h4>
                      <p className="mt-2 text-sm text-white/70">
                        {e.institution}
                      </p>
                      <p className="mt-2 label-eyebrow">
                        {e.period}
                        {e.location ? ` · ${e.location}` : ""}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* Certifications */}
          <div className="col-span-12 lg:col-span-7 lg:pl-8 lg:border-l lg:border-white/10">
            <Reveal>
              <p className="label-eyebrow">01.b / Certifications</p>
              <h3 className="mt-4 font-display font-black text-2xl sm:text-3xl tracking-tighter leading-tight">
                Always learning.
              </h3>
            </Reveal>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
              {CERTIFICATIONS.map((c, i) => (
                <Reveal
                  key={c.title}
                  delay={i * 80}
                  data-testid={`about-certification-${i}`}
                  className="bg-[#0a0a0a] hover:bg-[#0f0f0f] transition-colors p-6 group"
                >
                  <div className="flex items-start justify-between gap-3">
                    <Award
                      size={18}
                      className="text-white/50 group-hover:text-white transition-colors mt-1"
                    />
                    <span className="label-eyebrow">0{i + 1}</span>
                  </div>
                  <h4 className="mt-4 font-display font-bold text-base sm:text-lg tracking-tight leading-snug">
                    {c.title}
                  </h4>
                  <p className="mt-2 text-xs text-white/55 font-mono uppercase tracking-[0.15em]">
                    {c.issuer}
                  </p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
